import { InitialValues, ValidationErrors } from 'forms/types';
import { isPresent } from 'forms/validators';

import { WaitingPeriodFormValues } from '../form/types';

export const validate = ({
  waitingPeriod,
}: InitialValues<WaitingPeriodFormValues>): ValidationErrors<WaitingPeriodFormValues> => ({
  waitingPeriod: isPresent(waitingPeriod),
});
